export const USD_TO_SAR = 3.750;
